export default "__VITE_ASSET__89cbbe70__"